import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 0, // Adjust padding as needed
    backgroundColor: "white",
    height: "100%", // Use full height
    width: "100%", // Use full width
    position: "relative"
  },
  backgroundLogo: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: -1,
    opacity: 0.1, // Light transparency
  },
  contentWrapper: {
    marginTop: 30,
    position: "relative",
    zIndex: 1,
    padding: 20, // Adjust padding as needed
  },
  title: {
    fontSize: 20, // Keep font size as is
    marginBottom: 10, // Keep margin as is
    fontWeight: "bold",
    textAlign: "center",
  },
  row: {
    marginBottom: 5, // Keep margin as is
    flexDirection: "row",
    alignItems: "center",
  },
  label: {
    fontWeight: "bold",
    width: 120, // Adjust width if needed
    whiteSpace: "nowrap",
    fontSize: 14,
  },
  value: {
    flex: 1,
    whiteSpace: "nowrap",
    fontSize: 14,
  },
  signature: {
    marginTop: 10,
    alignSelf: "flex-end",
  },
});

const BackgroundImage = ({ logoImageData }) => (
  <View>
    <Image source={`${logoImageData}`} style={styles.backgroundLogo} />
  </View>
);

const Bill = ({
  clientDetails,
  plan,
  trainingType,
  selectedTrainer,
  logoImageBase64,
  logoImage, // Add this to support both prop names
  startDate,
  endDate,
  finalClientId,
  amountPaid,
  balanceAmount
}) => {
  // Use logoImageBase64 if available, otherwise use logoImage
  const logoImageData = logoImageBase64 || logoImage;
  
  // Get today's date
  const today = new Date();
  const todayFormatted = today.toLocaleDateString('en-GB'); // Format as DD/MM/YYYY
  
  return (
  <Document>
    <Page size="A4" style={styles.page}>
      <BackgroundImage logoImageData={logoImageData} />

      {/* First Instance of Content */}
      <View style={styles.contentWrapper}>
        <Text style={styles.title}>
          Welcome to Klimkaara Fitness Center
        </Text>
        <View style={{ marginTop: 10, alignItems: 'flex-end',fontSize: 14,marginBottom : 10 }}>
          <Text >Id : {finalClientId}</Text>
        </View>
        <View style={{ alignItems: 'flex-end',fontSize: 14,marginBottom : 10 }}>
          <Text >Date : {todayFormatted}</Text>
        </View>
        
        <View style={styles.row}>
          <Text style={styles.label}>Name :</Text>
          <Text style={styles.value}>{clientDetails.name}</Text>
        </View>
        {plan !== "None" && (
          <View style={styles.row}>
            <Text style={styles.label}>Plan Duration :</Text>
            <Text style={styles.value}>{plan} month(s)</Text>
          </View>
        )}
        <View style={styles.row}>
          <Text style={styles.label}>Training Type :</Text>
          <Text style={styles.value}>{trainingType}</Text>
        </View>
        {trainingType === "Personal" && (
          <View style={styles.row}>
            <Text style={styles.label}>Trainer :</Text>
            <Text style={styles.value}>{selectedTrainer}</Text>
          </View>
        )}
        <View style={styles.row}>
          <Text style={styles.label}>Phone :</Text>
          <Text style={styles.value}>{clientDetails.phonenumber}</Text>
        </View>
        {clientDetails.email && (
          <View style={styles.row}>
          <Text style={styles.label}>Email :</Text>
          <Text style={styles.value}>{clientDetails.email}</Text>
        </View>
        )}
        <View style={styles.row}>
          <Text style={styles.label}>Start Date :</Text>
          <Text style={styles.value}>{startDate}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>End Date :</Text> {/* Fixed duplicate label */}
          <Text style={styles.value}>{endDate}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Amount Paid :</Text> {/* Fixed duplicate label */}
          <Text style={styles.value}>Rs. {amountPaid}/-</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Balance Amount :</Text>
          <Text style={styles.value}>Rs. {balanceAmount}/-</Text>
        </View>

        {/* Phone number and Signature on same line */}
        <View style={{ marginTop: 20, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', fontSize: 14, marginBottom: 50 }}>
          <Text>Phone: 8885001113</Text>
          <Text>Signature</Text>
        </View>

        {/* Optional border for visual separation */}
        {/* Uncomment if needed */}
        
        <View style={{ borderBottomWidth: 1, borderBottomColor: '#000', borderStyle: 'dotted', marginVertical: 10 }} />
       
      </View>

      {/* Second Instance of Content - Duplicate of the First */}
      <View style={[styles.contentWrapper, {marginTop: 20}]}> {/* Added margin for separation */}
        <Text style={styles.title}>
          Klimkaara Fitness Center
        </Text>
        <View style={{ marginTop: 10, alignItems: 'flex-end',fontSize: 14,marginBottom : 10 }}>
          <Text >Id : {finalClientId}</Text>
        </View>
        <View style={{ alignItems: 'flex-end',fontSize: 14,marginBottom : 10 }}>
          <Text >Date : {todayFormatted}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Name :</Text>
          <Text style={styles.value}>{clientDetails.name}</Text>
        </View>
        {plan !== "None" && (
          <View style={styles.row}>
            <Text style={styles.label}>Plan Duration :</Text>
            <Text style={styles.value}>{plan} month(s)</Text>
          </View>
        )}
        <View style={styles.row}>
          <Text style={styles.label}>Training Type :</Text>
          <Text style={styles.value}>{trainingType}</Text>
        </View>
        {trainingType === "Personal" && (
          <View style={styles.row}>
            <Text style={styles.label}>Trainer :</Text>
            <Text style={styles.value}>{selectedTrainer}</Text>
          </View>
        )}
        <View style={styles.row}>
          <Text style={styles.label}>Phone :</Text>
          <Text style={styles.value}>{clientDetails.phonenumber}</Text>
        </View>
        {clientDetails.email && (
          <View style={styles.row}>
          <Text style={styles.label}>Email :</Text>
          <Text style={styles.value}>{clientDetails.email}</Text>
        </View>
        )}
        
        <View style={styles.row}>
          <Text style={styles.label}>Start Date :</Text>
          <Text style={styles.value}>{startDate}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>End Date :</Text> {/* Fixed duplicate label */}
          <Text style={styles.value}>{endDate}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Amount Paid :</Text> {/* Fixed duplicate label */}
          <Text style={styles.value}>Rs. {amountPaid}/-</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Balance Amount :</Text>
          <Text style={styles.value}>Rs. {balanceAmount}/-</Text>
        </View>

        {/* Phone number and Signature on same line */}
        <View style={{ marginTop: 20, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', fontSize: 14 }}>
          <Text>Gym Phone Number: 8885001113</Text>
          <Text>Signature</Text>
        </View>

      </View>

    </Page>
  </Document>
);
};

export default Bill;

